import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';
import {BsModalRef} from "ngx-bootstrap/modal";
import {ViajeService} from "../../services/viaje.service";
import {ViajeDTO} from "../../../dtos/viaje.dto";
import {ApiService} from "../../services/api.service";
import {GeneralResponseDTO} from "../../../dtos/response/general.response.dto";
import {AppMessage} from "../../app.message";
import {GetDetalleViajeResponseDTO} from "../../../dtos/response/getDetalleViaje.response.dto";
import moment from "moment";
import {DetalleViajeDTO} from "../../../dtos/detalleViaje.dto";
import {NgClass, NgForOf, NgIf, NgTemplateOutlet} from "@angular/common";
import {HttpErrorResponse} from "@angular/common/http";
import {PdfDTO} from "../../../dtos/pdf.dto";
import {ToastrService} from "ngx-toastr";
import {JornadaDTO} from "../../../dtos/jornada.dto";
import {EventService} from "../../services/event.service";
import {UserService} from "../../services/user.service";
import {TooltipModule} from "ngx-bootstrap/tooltip";

@Component({
  selector: 'app-modal-info-viaje',
  standalone: true,
  imports: [
    NgForOf,
    NgClass,
    NgIf,
    NgTemplateOutlet,
    TooltipModule
  ],
  templateUrl: './modal-info-viaje.component.html',
  styleUrl: './modal-info-viaje.component.scss'
})
export class ModalInfoViajeComponent {

  public viaje: ViajeDTO;
  public detalleViaje: DetalleViajeDTO;
  public procesandoPdf: boolean = false;

  constructor(private modalRef: BsModalRef, private viajeService: ViajeService, private apiService: ApiService,
              private toastr: ToastrService, private eventService: EventService, private userService: UserService) {
    this.viaje = this.viajeService.getViajeSeleccionado();
    this.getDetalleViaje();
    this.eventService.subscribe('VIAJE_ACTUALIZADO_MQTT_EVENT', (viaje: DetalleViajeDTO) => {
      if(viaje.uuid == this.viaje.uuid) {
        this.viaje = viaje;
        this.detalleViaje = viaje;
      }
    })
  }

  close() {
      this.modalRef.hide()
  }

  tienePermisoImprimirVoucherRuta(): boolean {
    return this.userService.tienePermiso('VOUCHER_RUTA_VIAJE');
  }

  /**
   * CON-1057: cambiar el bus o el conductor anula la confirmacion, y el vale de un viaje sin
   * confirmar no respalda nada. El backend ya lo rechaza con 409; aca se evita el intento.
   */
  get viajeConfirmado(): boolean {
    return !!this.viaje && this.viaje.confirmado;
  }

  get tooltipImprimirVoucherRuta(): string | null {
    if (!this.viajeConfirmado) return 'El viaje no está confirmado. Confírmelo antes de imprimir el vale';
    return null;
  }

  muestraHora(fecha: string) {
    if(!fecha)
      return '';
    return moment.utc(fecha).local().format('HH:mm');
  }

  muestraFechaDiaMes(fecha: string) {
    if(!fecha)
      return '';
    return moment.utc(fecha).local().format('DD MMM');
  }

  getDetalleViaje() {
    this.apiService.getDetalleViaje(this.viaje.uuid).subscribe((resp) => this.getDetalleViajeSuccess(resp), (error) => this.getDetalleViajeError(error));
  }

  getDetalleViajeSuccess(getDetalleViajeResponseDTO: GetDetalleViajeResponseDTO) {
    console.log('exito detalle viaje', getDetalleViajeResponseDTO);
    this.detalleViaje = getDetalleViajeResponseDTO.data;
  }

  getDetalleViajeError(error: HttpErrorResponse) {
    console.log('error detalle viaje', error);
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_DETALLE_VIAJE_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }

  /*muestraDuracion(): string {
    const inicio = moment.utc(this.viaje.fechahoraInicioOriginalPlanificado).local();
    const fin = moment.utc(this.viaje.fechahoraTerminoOriginalPlanificado).local();
    const xxx = moment.duration(fin.diff(inicio));
    return  xxx.humanize();
  }*/

  muestraDuracion(fechaInicio, fechaFin): string {
    if(!fechaInicio || !fechaFin)
      return '';

    const inicio = moment.utc(fechaInicio).local();
    const fin = moment.utc(fechaFin).local();
    //const duration = moment.duration(fin.diff(inicio));
    //return moment.utc(duration.asMilliseconds()).format("H[h] m[m]");
    return moment.duration(fin.diff(inicio)).format('HH:mm');
  }

  muestraDiferenciaHorasMinutos(fechaTermino: string, fechaLlegada: string) {
    if(!fechaTermino)
      return'';

    if(fechaLlegada)
      return this.muestraDiferenciaViajeTerminado(fechaTermino, fechaLlegada);

    const fecha2 = moment.utc(fechaTermino);
    const fecha1 = moment().utc();
    let diferencia = 0;
    if(fecha2 >= fecha1) {
      diferencia = fecha2.diff(fecha1);
      return moment.duration(diferencia).format('HH:mm');
    }else {
      diferencia = fecha1.diff(fecha2);
      return '+' + moment.duration(diferencia).format('HH:mm');
    }
  }

  muestraDiferenciaViajeTerminado(fechaTermino: string, fechaLlegada: string) {
    const fecha2 = moment.utc(fechaTermino);
    const fecha1 = moment.utc(fechaLlegada);
    let diferencia = 0;
    if(fecha2 >= fecha1) {
      diferencia = fecha2.diff(fecha1);
      return moment.duration(diferencia).format('HH:mm');
    }else {
      diferencia = fecha1.diff(fecha2);
      return '+' + moment.duration(diferencia).format('HH:mm');
    }
  }

  muestraDiferenciaHorasMinutosParadero(fechaPlanificada: string, fechaReal: string) {
    if(!fechaPlanificada || !fechaReal)
      return '';

    const fecha2 = moment.utc(fechaPlanificada);
    const fecha1 = moment.utc(fechaReal);
    if(fecha2 >= fecha1)
      return fecha1.diff(fecha2, 'minutes') + 'm';
    else
      return '+' + fecha1.diff(fecha2, 'minutes') + 'm';
  }

  muestraHorasTrabajadas() {
    if(!this.viaje.conductor?.jornadaEnCurso)
      return '';

    const minutos = this.viaje.conductor.jornadaEnCurso.minutosJornada - this.viaje.conductor.jornadaEnCurso.minutosRestantes;
    const duration = moment.duration(minutos * 60 * 1000);
    return moment.utc(duration.asMilliseconds()).format("H[h] m[m]");
    //return parseInt(this.viaje.conductor.jornadaEnCurso.minutosJornada) - parseInt(this.viaje.conductor.jornadaEnCurso.minutosRestantes);
  }

  muestraHorasDisponibles() {
    if(!this.viaje.conductor?.jornadaEnCurso || this.viaje.conductor.jornadaEnCurso.minutosRestantes == 0)
      return '00:00';

    return moment.duration(this.viaje.conductor.jornadaEnCurso.minutosRestantes * 60 * 1000).format("HH:mm");
  }

  muestraHorasAsignadas() {
    if(!this.viaje.conductor?.jornadaEnCurso)
      return '';

    const minutos = this.viaje.conductor.jornadaEnCurso.minutosJornada;
    return moment.duration(minutos * 60 * 1000).format("HH:mm");
  }

  convertirMinutosEnHoras(minutos: number) {
    if(!minutos)
      return '00:00';

    return moment.duration(minutos * 60 * 1000).format("HH:mm");
  }

  getRutaViajePDF() {
    this.procesandoPdf = true;
    this.apiService.getRutaViajePDF(this.viaje.uuid)
      .subscribe((resp) => this.getRutaViajePDFSuccess(resp), (error) => this.getRutaViajePDFError(error));
  }

  getRutaViajePDFSuccess(pdfDTO: PdfDTO) {
    console.log('exito pdf');
    this.procesandoPdf = false;
    if(pdfDTO.base64Content)
      pdfDTO.generatePdfFromBase64();
    else
      this.toastr.success(`Documento enviado a impresora ${pdfDTO.nombreImpresora}`, 'Éxito', { timeOut: environment.toastSuccessTimeout, extendedTimeOut: environment.toastSuccessTimeout, closeButton: true, tapToDismiss: false });
  }

  getRutaViajePDFError(error: HttpErrorResponse) {
    console.log('error kpis', error);
    this.procesandoPdf = false;
    const msg = error.error && error.error.msg ? error.error.msg : AppMessage.ERROR_GET_PDF_WS;
    //alert(msg);
    this.toastr.error(msg + (error['requestId'] ? ' Code: ' + error['requestId'] : ''), 'Error', { timeOut: environment.toastErrorTimeout, extendedTimeOut: environment.toastErrorTimeout, closeButton: true, tapToDismiss: false });
  }
}
